import PropTypes from "prop-types";
import React from "react";
import wrappable from "utils/wrappable";

const SelectDSFR = wrappable((props) => {
  const { name, error = false, errorMessage = "", ...others } = props;
  return (
    <>
      <select name={name} className="fr-select" {...others} />
      {error && errorMessage && (
        <div className="fr-messages-group" id={`select-${name}-message`} aria-live="polite">
          <p className="fr-message fr-message--error" id={`select-${name}-error`}>
            {errorMessage}
          </p>
        </div>
      )}
    </>
  );
});

SelectDSFR.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default SelectDSFR;
